// A page the browser kept in its back-forward cache comes back as it was left, still signed in, even after a
// Logout in this tab ended its sign-in: the Logout crossing between the two apps removes the other app's stored
// sign-in only (ADR-007), and a restored page never reads it again. Such a page is loaded again instead, so it
// starts from this tab's sign-in as it is now (W3 security review finding 2, adversarial finding 3). A page that
// loaded normally is left alone.
export function reloadWhenRestored(event, reload = () => window.location.reload()) {
  if (event && event.persisted) reload()
}
